import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_res$Bolt0 from "bolt0/./bolt0_res.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";

function Make(R, L) {
  var create = function create(of_data, data) {
    var match = Bolt0_res$Bolt0.try_with(function (param) {
      return Curry._1(of_data, data);
    });

    if (match[0] >= 106380200) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      return match[1];
    }
  };

  var $$enum = function $$enum(l) {
    return function (param) {
      return create(function (param) {
        if (typeof param === "number" || param[0] !== -976970511) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var x = param[1];
          var match = Bolt0_list$Bolt0.find_opt(l, function (name) {
            if (x === name) {
              return name;
            }
          });

          if (match !== undefined) {
            return (
              /* `Ok */
              [17724, match]
            );
          } else {
            return (
              /* Invalid */
              144245463
            );
          }
        }
      }, param);
    };
  };

  var map = function map(t, f, data) {
    var match = Curry._1(t, data);

    if (typeof match === "number") {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var x = match[1];
      var match$1 = Bolt0_res$Bolt0.try_with(function (param) {
        return Curry._1(f, x);
      });

      if (match$1[0] >= 106380200) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return match$1[1];
      }
    }
  };

  var data = function data(param) {
    return create(function (x) {
      return (
        /* `Ok */
        [17724, x]
      );
    }, param);
  };

  var bool = function bool(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 737456202) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var $$char = function $$char(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 748194550) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var $$float = function $$float(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 365180284) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var $$int = function $$int(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 3654863) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var list = function list(arg_type) {
    var list$1 = function list$1(param) {
      return create(function (param) {
        if (typeof param === "number" || param[0] !== 848054398) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          return (
            /* `Ok */
            [17724, param[1]]
          );
        }
      }, param);
    };

    return function (param) {
      return map(list$1, function (l) {
        var match = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(function (data) {
          var match = Curry._1(arg_type, data);

          if (typeof match === "number") {
            return (
              /* `Error */
              [106380200,
              /* Invalid */
              144245463]
            );
          } else {
            return (
              /* `Ok */
              [17724, match[1]]
            );
          }
        }, l));

        if (match[0] >= 106380200) {
          return match[1];
        } else {
          return (
            /* `Ok */
            [17724, match[1]]
          );
        }
      }, param);
    };
  };

  var array = function array(arg_type) {
    var partial_arg = list(arg_type);
    return function (param) {
      return map(partial_arg, function (l) {
        return (
          /* `Ok */
          [17724, $$Array.of_list(l)]
        );
      }, param);
    };
  };

  var option = function option(arg_type) {
    var option$1 = function option$1(param) {
      return create(function (param) {
        if (typeof param === "number") {
          if (param !== 870828711) {
            return (
              /* Invalid */
              144245463
            );
          } else {
            return (
              /* `Ok */
              [17724, undefined]
            );
          }
        } else if (param[0] !== 925978388) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          return (
            /* `Ok */
            [17724, param[1]]
          );
        }
      }, param);
    };

    return function (param) {
      return map(option$1, function (param) {
        if (param !== undefined) {
          var match = Curry._1(arg_type, param);

          if (typeof match === "number") {
            return (
              /* Invalid */
              144245463
            );
          } else {
            return (
              /* `Ok */
              [17724, Caml_option.some(match[1])]
            );
          }
        } else {
          return (
            /* `Ok */
            [17724, undefined]
          );
        }
      }, param);
    };
  };

  var viz = function viz(arg_type) {
    var viz$1 = function viz$1(param) {
      return create(function (param) {
        if (typeof param === "number" || param[0] !== 4300231) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          return (
            /* `Ok */
            [17724, param[1]]
          );
        }
      }, param);
    };

    return function (param) {
      return map(viz$1, arg_type, param);
    };
  };

  var record = function record(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 847309489) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var tagged = function tagged(tag, arg_type) {
    var tagged$1 = function tagged$1(param) {
      return create(function (param) {
        if (typeof param === "number" || param[0] !== 847309489) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var record = param[1];

          var match = Curry._2(R.find, record, Curry._1(L.positional_exn, 1));

          if (match !== undefined) {
            var data = match;

            if (typeof data === "number" || data[0] !== -976970511) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var match$1 = $$String.equal(data[1], tag);

              if (match$1) {
                var match$2 = Curry._2(R.find, record, Curry._1(L.positional_exn, 2));

                if (match$2 !== undefined) {
                  return (
                    /* `Ok */
                    [17724, match$2]
                  );
                } else {
                  return (
                    /* Invalid */
                    144245463
                  );
                }
              } else {
                return (
                  /* Invalid */
                  144245463
                );
              }
            }
          } else {
            return (
              /* Invalid */
              144245463
            );
          }
        }
      }, param);
    };

    return function (param) {
      return map(tagged$1, arg_type, param);
    };
  };

  var table = function table(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 848054398) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        var match = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(function (param) {
          if (typeof param === "number" || param[0] !== 847309489) {
            return (
              /* `Error */
              [106380200,
              /* Invalid */
              144245463]
            );
          } else {
            return (
              /* `Ok */
              [17724, param[1]]
            );
          }
        }, param[1]));

        if (match[0] >= 106380200) {
          return match[1];
        } else {
          return (
            /* `Ok */
            [17724, match[1]]
          );
        }
      }
    }, param);
  };

  var string = function string(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== -976970511) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var blob_id = function blob_id(param) {
    return create(function (param) {
      if (typeof param === "number" || param[0] !== 295523485) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }, param);
  };

  var required = function required(arg_type, key, map) {
    var match = Curry._2(R.find, map, key);

    if (match !== undefined) {
      return Curry._1(arg_type, match);
    } else {
      return (
        /* Not_found */
        -358247754
      );
    }
  };

  var optional = function optional(arg_type, key, map) {
    var match = Curry._2(R.find, map, key);

    if (match !== undefined) {
      var match$1 = Curry._1(arg_type, match);

      if (typeof match$1 === "number") {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, Caml_option.some(match$1[1])]
        );
      }
    } else {
      return (
        /* `Ok */
        [17724, undefined]
      );
    }
  };

  var optional_with_default = function optional_with_default(arg_type, $$default, key, map) {
    var match = Curry._2(R.find, map, key);

    if (match !== undefined) {
      var match$1 = Curry._1(arg_type, match);

      if (typeof match$1 === "number") {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, match$1[1]]
        );
      }
    } else {
      return (
        /* `Ok */
        [17724, $$default]
      );
    }
  };

  var map$1 = function map$1(t, f, label, record) {
    var match = Curry._2(t, label, record);

    if (typeof match === "number") {
      if (match >= 144245463) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* Not_found */
          -358247754
        );
      }
    } else {
      return Curry._1(f, match[1]);
    }
  };

  var Flag = {
    required: required,
    optional: optional,
    optional_with_default: optional_with_default,
    map: map$1
  };

  var $$return = function $$return(x, param) {
    return (
      /* `Ok */
      [17724, x]
    );
  };

  var map$2 = function map$2(ma, f, record) {
    return Bolt0_res$Bolt0.map(Curry._1(ma, record), f);
  };

  var map_error = function map_error(ma, f, record) {
    return Bolt0_res$Bolt0.map_error(Curry._1(ma, record), f);
  };

  var bind = function bind(t, f) {
    return function (param) {
      var tt = function tt(param) {
        return Bolt0_res$Bolt0.map(Curry._1(t, param), f);
      };

      var record = param;

      var match = Curry._1(tt, record);

      if (match[0] >= 106380200) {
        return (
          /* `Error */
          [106380200, match[1]]
        );
      } else {
        return Curry._1(match[1], record);
      }
    };
  };

  var flag1 = function flag1(key, flg, record) {
    var e = Curry._2(flg, key, record);

    if (typeof e === "number") {
      return (
        /* `Error */
        [106380200,
        /* tuple */
        [key, e]]
      );
    } else {
      return (
        /* `Ok */
        [17724, e[1]]
      );
    }
  };

  var errs = function errs(t) {
    return function (param) {
      return Bolt0_res$Bolt0.map_error(Curry._1(t, param), Bolt0_list$Bolt0.$$return);
    };
  };

  var flag = function flag(key, flg) {
    return function (param) {
      return Bolt0_res$Bolt0.map_error(flag1(key, flg, param), Bolt0_list$Bolt0.$$return);
    };
  };

  var parse = function parse(record, param) {
    return Curry._1(param, record);
  };

  var both = function both(t, u, record) {
    var match = Curry._1(t, record);

    var match$1 = Curry._1(u, record);

    if (match[0] >= 106380200) {
      var e1 = match[1];

      if (match$1[0] >= 106380200) {
        return (
          /* `Error */
          [106380200, Pervasives.$at(e1, match$1[1])]
        );
      } else {
        return (
          /* `Error */
          [106380200, e1]
        );
      }
    } else if (match$1[0] >= 106380200) {
      return (
        /* `Error */
        [106380200, match$1[1]]
      );
    } else {
      return (
        /* `Ok */
        [17724,
        /* tuple */
        [match[1], match$1[1]]]
      );
    }
  };

  var Open_on_rhs = {
    $$return: $$return
  };
  var Let_syntax = {
    $$return: $$return,
    map: map$2,
    bind: bind,
    both: both,
    Open_on_rhs: Open_on_rhs
  };
  var Let_syntax$1 = {
    Let_syntax: Let_syntax
  };

  var $less$star$great = function $less$star$great(r1, r2, record) {
    var match = both(r1, r2, record);

    if (match[0] >= 106380200) {
      return (
        /* `Error */
        [106380200, match[1]]
      );
    } else {
      var match$1 = match[1];
      return (
        /* `Ok */
        [17724, Curry._1(match$1[0], match$1[1])]
      );
    }
  };

  var Applicative_infix = {
    $less$star$great: $less$star$great
  };

  var tag = Curry._1(L.positional_exn, 1);

  var payload = Curry._1(L.positional_exn, 2);

  var Label = {
    tag: tag,
    payload: payload
  };
  var Const = {
    Label: Label
  };

  var parse$1 = function parse$1(record, arg_type) {
    var tag$1 = function tag$1(param) {
      return flag1(tag, function (param, param$1) {
        return required(string, param, param$1);
      }, param);
    };

    var payload$1 = function payload$1(param) {
      return flag1(payload, function (param, param$1) {
        return required(arg_type, param, param$1);
      }, param);
    };

    var make = function make(tag, payload) {
      return (
        /* tuple */
        [tag, payload]
      );
    };

    var param = record;
    return $less$star$great(function (param) {
      return $less$star$great(function (param) {
        return (
          /* `Ok */
          [17724, make]
        );
      }, function (param) {
        return Bolt0_res$Bolt0.map_error(tag$1(param), Bolt0_list$Bolt0.$$return);
      }, param);
    }, function (param) {
      return Bolt0_res$Bolt0.map_error(payload$1(param), Bolt0_list$Bolt0.$$return);
    }, param);
  };

  var Tagged = {
    Const: Const,
    parse: parse$1
  };
  return {
    R: R,
    Arg_type: {
      create: create,
      $$enum: $$enum,
      map: map,
      data: data,
      bool: bool,
      $$char: $$char,
      $$float: $$float,
      $$int: $$int,
      list: list,
      array: array,
      option: option,
      viz: viz,
      tagged: tagged,
      record: record,
      table: table,
      string: string,
      blob_id: blob_id
    },
    Flag: Flag,
    $$return: $$return,
    map: map$2,
    map_error: map_error,
    flag: flag,
    flag1: flag1,
    errs: errs,
    parse: parse,
    Tagged: Tagged,
    Applicative_infix: Applicative_infix,
    Let_syntax: Let_syntax$1
  };
}

var Param = {
  Make: Make
};
export { Param };
/* No side effect */